import { Text } from '@radix-ui/themes'
import moment from 'moment/moment'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { PiCopyrightLight } from 'react-icons/pi'

import { Image } from '~/components/ui/image'
import { ROOT_I18NEXT } from '~/routes/_layout/root.component'

type CopyrightProps = {
  showLogo?: boolean
}

const Copyright: React.FC<CopyrightProps> = ({ showLogo = true }) => {
  const { t } = useTranslation(ROOT_I18NEXT.routeRoot)

  return (
    <div className="flex flex-col items-center md:items-start gap-y-3">
      {showLogo && (
        <Image
          api={false}
          src="/pwa/img/compress/logo/logo.webp"
          alt="Brand Logo"
          width={200}
          className="-ml-2.5"
        />
      )}
      <Text size="1" color="gray" className="flex flex-col xs:flex-row gap-1 my-1 items-center">
        <div className="flex items-center gap-x-1">
          <span id="copyright">
            {t('label.copyright')}
          </span>
          <span>
            <PiCopyrightLight aria-labelledby="copyright"/>
          </span>
          <span>
            {moment().format('YYYY')}
          </span>
        </div>
        <div className="flex items-center gap-x-1">
          <span>
            {t('label.brand')}.
          </span>
          <span>
            {t('label.allRightsReserved')}.
          </span>
        </div>
      </Text>
    </div>
  )
}


export {
  Copyright,
  type CopyrightProps,
}
